import React, {useEffect, useRef} from 'react';
import classnames from 'classnames';
import DetectionItem from './DetectionItem';

export default function SkinDetections({
  isHd,
  isLandscape,
  isShowSkinType,
  showSkinTypeItems,
  isShowSkinHealth,
  transformedSequenceOfCategory,
  detectionMapping,
  activeDetection,
  setActiveDetection,
  scoreFormat,
  activeLang,
}) {
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const startY = useRef(0);
  const scrollLeft = useRef(0);
  const scrollTop = useRef(0);

  useEffect(() => {
    if (!isLandscape && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [isLandscape]);

  const startDrag = (x, y) => {
    isDragging.current = true;
    scrollRef.current.classList.add('active');
    startX.current = x;
    startY.current = y;
    scrollLeft.current = scrollRef.current.scrollLeft;
    scrollTop.current = scrollRef.current.scrollTop;
  };

  const endDrag = () => {
    isDragging.current = false;
    scrollRef.current.classList.remove('active');
  };

  const moveDrag = (x, y) => {
    if (!isDragging.current) return;

    const walkX = (x - startX.current) * 1;
    const walkY = (y - startY.current) * 1;

    if (isLandscape) {
      const newScrollTop = scrollTop.current - walkY;
      const maxScrollTop =
        scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
      scrollRef.current.scrollTop = Math.max(
        0,
        Math.min(newScrollTop, maxScrollTop)
      );
    } else {
      const newScrollLeft = scrollLeft.current - walkX;
      const maxScrollLeft =
        scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
      scrollRef.current.scrollLeft = Math.max(
        0,
        Math.min(newScrollLeft, maxScrollLeft)
      );
      scrollRef.current.scrollTop = 0;
    }
  };

  const handleMouseDown = e => {
    startDrag(
      e.pageX - scrollRef.current.offsetLeft,
      e.pageY - scrollRef.current.offsetTop
    );
    document.body.style.overflow = '';
  };

  const handleMouseUp = () => {
    endDrag();
    document.body.style.overflow = '';
  };

  const handleMouseLeave = () => {
    endDrag();
    document.body.style.overflow = '';
  };

  const handleMouseMove = e => {
    if (!isDragging.current) return;
    e.preventDefault();
    moveDrag(
      e.pageX - scrollRef.current.offsetLeft,
      e.pageY - scrollRef.current.offsetTop
    );
  };

  const handleTouchStart = e => {
    const touch = e.touches[0];
    startDrag(
      touch.pageX - scrollRef.current.offsetLeft,
      touch.pageY - scrollRef.current.offsetTop
    );
    document.body.style.overflow = '';
  };

  const handleTouchEnd = () => {
    endDrag();
    // 恢復頁面滾動
    document.body.style.overflow = '';
  };

  const handleTouchMove = e => {
    if (!isDragging.current) return;
    const touch = e.touches[0];
    moveDrag(
      touch.pageX - scrollRef.current.offsetLeft,
      touch.pageY - scrollRef.current.offsetTop
    );
  };

  const handleMouseEnter = () => {
    document.body.style.overflow = '';
  };

  return (
    <div
      ref={scrollRef}
      className={classnames({
        'skincaredetectionpreview-detections': !isHd,
        'skincaredetectionpreview-detections__hd': isHd,
        'skincaredetectionpreview-detections--landscape': isLandscape,
        'skincaredetectionpreview-detections__hd--skintype':
          !isLandscape && isShowSkinType,
        'skincaredetectionpreview-detections__hd--skintype--not-show-item':
          !isLandscape && isShowSkinType && !showSkinTypeItems,
        'skincaredetectionpreview-detections__hd--landscape--skintype':
          isLandscape && isShowSkinType,
        'skincaredetectionpreview-detections__hd--landscape--skintype--not-show-item':
          isLandscape && isShowSkinType && !showSkinTypeItems,
      })}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {isShowSkinHealth && (
        <DetectionItem
          categoryKey="skin_health"
          detectionMapping={detectionMapping}
          activeDetection={activeDetection}
          setActiveDetection={setActiveDetection}
          isLandscape={isLandscape}
          scoreFormat={scoreFormat}
          activeLang={activeLang}
        />
      )}
      {transformedSequenceOfCategory
        .filter(c => c.value && c.value !== 'dark_circle')
        .map(category =>
          category.value && category.disabled ? null : (
            <DetectionItem
              key={category.value}
              categoryKey={category.value}
              detectionMapping={detectionMapping}
              activeDetection={activeDetection}
              setActiveDetection={setActiveDetection}
              isLandscape={isLandscape}
              scoreFormat={scoreFormat}
              activeLang={activeLang}
            />
          )
        )}
    </div>
  );
}
